import React, { useEffect, useState } from 'react';
import { supabase } from './supabaseClient';

export default function ProfileBlogs({ user }) {
  const [blogs, setBlogs] = useState([]);
  const [likesMap, setLikesMap] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchBlogs() {
      setLoading(true);
      const { data: blogData } = await supabase
        .from('blog_posts')
        .select('id, title, views')
        .eq('author_id', user.id);
      setBlogs(blogData || []);
      // Fetch likes for user's blogs
      if (blogData && blogData.length > 0) {
        const blogIds = blogData.map(b => b.id);
        const { data: likesData } = await supabase
          .from('blog_likes')
          .select('post_id')
          .in('post_id', blogIds);
        // Count likes per blog
        const map = {};
        blogIds.forEach(id => { map[id] = 0; });
        likesData.forEach(like => { map[like.post_id] = (map[like.post_id] || 0) + 1; });
        setLikesMap(map);
      } else {
        setLikesMap({});
      }
      setLoading(false);
    }
    if (user) fetchBlogs();
  }, [user]);

  if (!user) return <div className="container mt-5"><div className="alert alert-warning">You must be logged in to view your blogs.</div></div>;
  if (loading) return <div className="container mt-5 text-center"><div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading...</span></div></div>;

  return (
    <div className="container mt-5" style={{maxWidth: 900}}>
      <h3 className="mb-4">My Blogs</h3>
      {blogs.length === 0 ? (
        <div className="alert alert-info">No blogs submitted yet.</div>
      ) : (
        <div className="table-responsive">
          <table className="table table-bordered align-middle">
            <thead className="table-light">
              <tr>
                <th>Title</th>
                <th>Likes</th>
                <th>Views</th>
              </tr>
            </thead>
            <tbody>
              {blogs.map(blog => (
                <tr key={blog.id}>
                  <td>{blog.title}</td>
                  <td>{likesMap[blog.id] || 0}</td>
                  <td>{blog.views || 0}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
} 